var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.02637H7C6.46957 5.02637 5.96086 5.23708 5.58579 5.61215C5.21071 5.98723 5 6.49593 5 7.02637V19.0264C5 19.5568 5.21071 20.0655 5.58579 20.4406C5.96086 20.8157 6.46957 21.0264 7 21.0264H17C17.5304 21.0264 18.0391 20.8157 18.4142 20.4406C18.7893 20.0655 19 19.5568 19 19.0264V7.02637C19 6.49593 18.7893 5.98723 18.4142 5.61215C18.0391 5.23708 17.5304 5.02637 17 5.02637H15",
    stroke: "#1C7CC4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.02637C9 4.49593 9.21071 3.98723 9.58579 3.61215C9.96086 3.23708 10.4696 3.02637 11 3.02637H13C13.5304 3.02637 14.0391 3.23708 14.4142 3.61215C14.7893 3.98723 15 4.49593 15 5.02637C15 5.5568 14.7893 6.06551 14.4142 6.44058C14.0391 6.81565 13.5304 7.02637 13 7.02637H11C10.4696 7.02637 9.96086 6.81565 9.58579 6.44058C9.21071 6.06551 9 5.5568 9 5.02637Z",
    stroke: "#1C7CC4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.0264H14",
    stroke: "#1C7CC4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.0264V16.0264",
    stroke: "#1C7CC4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServIcon4);
export default __webpack_public_path__ + "static/media/serv-icon4.dbddc3aad73b27bec3b435179962ee0e.svg";
export { ForwardRef as ReactComponent };